function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h1024v956H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#about-science_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M707.585 37.032c183.716-26.96 289.806-14.828 319.885-5.392L1080 55.229v822.897L1027.47 928c-61.417 33.968-152.197 29.88-189.91 23.589-64.426-16.625-246.076-43.134-457.269-16.175C169.099 962.373 30.101 938.11-13 922.608V18.16c98.592-32.89 233.685-13.704 288.908 0 67.344 17.524 247.962 45.83 431.677 18.872z",
  fill: "#F4F6D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 170.52c56.67 12.685 157.718 57.665 108.554 136.105-61.454 98.05-27.811 113.272 95.546 20.147C1063.46 233.648 1121.77 155.297 1207 145M-251 402.52c56.67 12.685 157.718 57.665 108.554 136.105-61.454 98.05-27.811 113.272 95.546 20.147C76.457 465.648 134.771 387.297 220 377M1022.12 782.266c9.02-44.542 9.11-131.098-62.627-120.99-89.669 12.636-89.814-16.261 16.083-74.702 105.894-58.442 180.484-75.118 215.034-132.736",
  stroke: "gray"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.59 514.283a2.656 2.656 0 01-2.641-2.603 2.648 2.648 0 012.602-2.684h.042a2.647 2.647 0 012.58 2.624 2.647 2.647 0 01-2.54 2.663h-.043z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M663.935 488.703a2.296 2.296 0 012.108 1.401 2.283 2.283 0 01-.465 2.487 2.27 2.27 0 01-1.609.695h-.036a2.288 2.288 0 01-2.233-2.273 2.291 2.291 0 012.196-2.31h.039zm0-.703h-.05a2.995 2.995 0 00-2.023 5.097 3.001 3.001 0 002.068.893h.05a2.992 2.992 0 002.054-.924 2.993 2.993 0 00-.031-4.174 2.996 2.996 0 00-2.068-.892z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M678.862 688.773a2.649 2.649 0 01-2.456-3.614 2.652 2.652 0 011.408-1.454c.319-.137.662-.21 1.009-.215h.042a2.642 2.642 0 11.039 5.283h-.042z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M678.862 683.842a2.298 2.298 0 012.251 2.711 2.298 2.298 0 01-1.341 1.685 2.299 2.299 0 01-.876.187h-.034a2.29 2.29 0 01-2.231-2.276 2.291 2.291 0 012.197-2.307h.037-.003zm.003-.704h-.048a2.995 2.995 0 00-2.081 5.125 2.99 2.99 0 002.123.862h.051a2.995 2.995 0 002.971-3.016 2.992 2.992 0 00-3.016-2.971z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.647 741.444a2.656 2.656 0 01-2.639-2.603 2.649 2.649 0 012.6-2.684h.039a2.647 2.647 0 012.581 2.624 2.643 2.643 0 01-2.541 2.663h-.04z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.648 736.509c.45 0 .89.133 1.265.382a2.286 2.286 0 01.987 2.331 2.285 2.285 0 01-2.216 1.87h-.036a2.296 2.296 0 01-2.108-1.401 2.28 2.28 0 01-.142-1.313c.082-.443.293-.851.607-1.174a2.27 2.27 0 011.609-.695h.034zm0-.704h-.048a2.996 2.996 0 00.045 5.99h.048a2.997 2.997 0 00-.045-5.99z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.092 698.871a2.642 2.642 0 01-2.519-1.834 2.642 2.642 0 012.536-3.455 2.643 2.643 0 012.487 3.491 2.635 2.635 0 01-2.504 1.798z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.089 693.936c.249-.001.496.041.731.124a2.293 2.293 0 011.438 2.904 2.287 2.287 0 01-1.833 1.528 2.288 2.288 0 01-2.619-2.097 2.289 2.289 0 012.283-2.459zm0-.703a2.993 2.993 0 00-.96 5.838 2.991 2.991 0 003.92-2.349 2.989 2.989 0 00-2.004-3.323 2.88 2.88 0 00-.956-.16v-.006z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.717 765.553l-3.498 2.449 2.449 3.499 3.498-2.449-2.449-3.499z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.619 766.055l2.045 2.921-2.923 2.045-2.031-2.92 2.923-2.046h-.014zm.189-.979l-4.077 2.85 2.853 4.077 4.074-2.853-2.853-4.074h.003z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.238 574.347l-3.502 2.434 2.434 3.502 3.502-2.434-2.434-3.502z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.411 574.532l2.045 2.923-2.92 2.046-2.046-2.924 2.921-2.045zm.174-.976l-4.074 2.85 2.85 4.074 4.077-2.853-2.853-4.074v.003z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420.648 529.672l-3.284 2.729 2.729 3.285 3.285-2.73-2.73-3.284z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.733 471.988l2.279 2.743-2.743 2.281-2.281-2.746 2.745-2.278zm.09-.988L498 474.179l3.179 3.824 3.824-3.18-3.18-3.823z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.034 737.789l-7.051 5.858M705.677 611.762l-3.748-8.367M708.825 736.528l8.367-3.747M615 768.43l2.026-8.941M341.466 505.083l-4.642-7.236",
  stroke: "#000",
  strokeWidth: 0.844,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M440.243 666.837s-5.908-10.95-4.881-14.126c1.452-4.518 11.051-10.157 11.051-10.157",
  stroke: "#fff",
  strokeWidth: 1.407,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M527.229 651.282H495.28a15.674 15.674 0 01-11.091-4.597 15.678 15.678 0 01-4.589-11.094 15.68 15.68 0 0115.68-15.679h31.951a15.682 15.682 0 0114.488 21.683 15.67 15.67 0 01-8.487 8.492 15.674 15.674 0 01-6.003 1.195z",
  fill: "#53C0DA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M634.673 775.176l-28.93 24.075-94.599-100.687-94.708 100.898-28.601-24.432 94.863-103.112a38.648 38.648 0 0112.679-9.115 38.68 38.68 0 0144.228 9.115l95.068 103.258z",
  fill: "#235544"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.137 791.814c7.901-6.746 12.621-14.187 10.543-16.622-2.078-2.434-10.168 1.061-18.069 7.806-7.901 6.746-12.621 14.188-10.543 16.622 2.079 2.434 10.169-1.061 18.069-7.806z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620.578 783.014l17.454 21.191 36.465-39.202-37.978 20.774-6.972-8.336",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M394.607 767.667s47.491-2.186 47.42-17.595c-.05-11.344-20.296-11.89-20.296-11.89",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M449.809 763.914s-21.514-14.824-28.21-9.054c-6.696 5.771 6.31 32.374 6.31 32.374M495.249 662.862s-11.609 19.992-.701 31.116c10.908 11.124 39.827-26.781 39.827-26.781M460.815 752.188s-4.358-26.989 17.573-40.378M439.546 718.821s40.834 24.524 41.756-4.676",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M639.535 788.38l3.829-9.909M644.59 786.272l3.829-9.909M649.885 783.709l3.829-9.909",
  stroke: "#fff",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M549.19 696.552s-41.529 5.07-31.327-36.484",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M416.469 799.432c2.078-2.434-2.642-9.876-10.543-16.621-7.901-6.746-15.991-10.241-18.069-7.807-2.078 2.435 2.642 9.876 10.543 16.622s15.99 10.241 18.069 7.806z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.919 782.902l-17.454 21.188L348 764.89l37.978 20.772 6.969-8.334",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.962 788.267l-3.829-9.912M377.907 786.16l-3.829-9.912M372.612 783.597l-3.829-9.912",
  stroke: "#fff",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M549.286 745.829h-69.21a3.781 3.781 0 01-3.781-3.781v-53.267a3.78 3.78 0 013.781-3.781h15.817a3.79 3.79 0 013.067 1.57l3.024 4.164a3.778 3.778 0 003.067 1.57h44.232a3.781 3.781 0 013.781 3.781v45.963a3.783 3.783 0 01-1.105 2.673 3.772 3.772 0 01-2.673 1.108z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M527.119 705.51l14.171-22.952",
  stroke: "#F5BED7",
  strokeWidth: 1.969,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M535.753 654.07l12.697 18.205-21.686 35.12 17.12 11.428s30.41-37.46 27.546-50.9c-2.951-13.851-34.174-43.746-34.174-43.746M467.345 673.719l-8.722-14.937 22.457-10.902",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M487.669 686.278a14.31 14.31 0 01-11.322 14.3 14.306 14.306 0 01-16.17-8.44 14.308 14.308 0 1127.492-5.86z",
  fill: "#FFED80"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494.548 621.074c-12.32.306-58.114 22.321-60.078 31.262-1.963 8.941 19.902 37.773 22.871 39.805 3.348 2.29 18.644 7.348 18.942 5.452.355-2.251-13.954-9.321-13.954-9.321s18.914 5.959 19.379 3.939c.489-2.127-18.344-10.331-18.344-10.331s14.956.914 14.745-.709c-.244-1.879-13.504-6.133-13.504-6.133",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526.483 614.547a13.118 13.118 0 01-25.959-2.915c.018-.825.112-1.646.281-2.453a13.113 13.113 0 015.623-8.409 13.113 13.113 0 019.935-1.908 13.12 13.12 0 018.338 5.727 13.11 13.11 0 011.785 9.958h-.003z",
  fill: "#FFE233"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528.298 600.367a5.449 5.449 0 01-5.427 4.331 5.45 5.45 0 01-4.632-8.152 5.447 5.447 0 0110.059 3.821z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519.773 597.019a3.319 3.319 0 01-6.555-.737c.004-.209.027-.417.07-.622a3.323 3.323 0 013.933-2.59 3.326 3.326 0 012.586 2.649c.079.431.072.872-.02 1.3h-.014z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M521.444 621.074s-2.672-.762-2.416-3.25",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.66 616.375c.008-1.248-.622-2.263-1.407-2.268-.785-.005-1.427 1.002-1.435 2.25-.008 1.248.622 2.263 1.407 2.268.784.005 1.427-1.002 1.435-2.25zM517.934 616.499c.008-1.247-.622-2.263-1.406-2.268-.785-.005-1.427 1.003-1.435 2.25-.008 1.248.622 2.263 1.406 2.268.785.005 1.427-1.002 1.435-2.25z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505.467 610.155a4.769 4.769 0 01-5.195 3.748 4.765 4.765 0 01-4.233-4.809 4.77 4.77 0 01.102-.891 4.757 4.757 0 013.78-3.706 4.748 4.748 0 011.859.019 4.753 4.753 0 013.011 2.056 4.748 4.748 0 01.676 3.583z",
  fill: "#FFE233"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.314 604.556s-5.163 1.953-13.097-1.277l-2.186 7.619-4.782-2.161s-.366-4.738-5.02-4.054c0 0 1.483-8.896 7.034-9.549 9.664-1.136 16.841 4.524 18.051 9.422z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.586 781.326s-10.972-36.513-43.791-15.01M592.469 785.121s-18.85-46.421 5.239-50.079M552.201 710.943s22.681 7.273 22.594 20.082c-.087 12.81-16.973 17.218-16.973 17.218",
  stroke: "#C6D13E",
  strokeWidth: 1.125,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M481.213 745.829h68.366a3.782 3.782 0 003.404-2.135l16.036-33.167a3.784 3.784 0 00-.201-3.655 3.771 3.771 0 00-3.203-1.772h-68.366a3.777 3.777 0 00-3.404 2.135l-16.037 33.167a3.779 3.779 0 003.405 5.427z",
  fill: "#C6D13E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.458 678.437s-4.327 3.376-3.635 5.022c.692 1.646 6.448.433 6.448.433",
  stroke: "#000",
  strokeWidth: 1.125,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771.337 511.834l.062-.005.007.061c.021.189.049.465.071.809.044.689.067 1.65-.018 2.738-.171 2.183-.773 4.842-2.471 6.846-3.792 4.474-8.417 4.125-9.324 3.962-.332-.805-1.679-5.309 1.974-9.956h0c1.624-2.067 4.108-3.19 6.213-3.795a19.479 19.479 0 013.486-.66z",
  stroke: "#000",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M368.361 577.125a5.78 5.78 0 00-1.479 7.756c.105.169-.446.019.033.706.479.688.504.028.605.14 2.077 2.305 5.633 2.71 8.156.856a5.771 5.771 0 002.203-6.047c-.064-.262.624-.134.631-.563.003-.137-.219-.14-.271-.291-.265-.773-.929-1.811-1.219-2.186-.011-.015-.213-.472-.228-.481-.274-.144-.439.779-.673.563-2.111-1.944-5.39-2.194-7.758-.453zM353.789 568.042c-3.443-2.29-7.974-1.488-10.488 1.729-.165.211-.227-.554-.878.37s.196.648.099.829c-1.968 3.692-.857 8.371 2.641 10.698a7.757 7.757 0 008.655-.022c.303-.203.454.726 1 .536.175-.06.077-.342.245-.477.857-.693 1.868-2.013 2.21-2.554.013-.021.5-.487.503-.511.058-.412-1.185-.193-1.02-.589 1.497-3.567.316-7.825-2.967-10.009zM369.7 563.426c.45-1.852-.734-3.716-2.681-4.335-.128-.04.218-.183-.329-.329-.547-.146-.267.183-.368.168-2.071-.308-4.051.88-4.509 2.761-.356 1.461.306 2.93 1.558 3.789.148.102-.257.307-.071.518.06.067.173-.018.266.036.476.271 1.271.516 1.584.584.013.003.317.146.328.144.203-.036-.122-.548.092-.535 1.929.12 3.7-1.035 4.13-2.801z",
  fill: "#235544"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406 499.109s6.589 14.57 12.387 17.677c5.799 3.106 13.128-1.609 20.815 1.531 7.687 3.14 8.234 9.266 9.962 17.59 1.727 8.325 19.726 10.927 19.726 10.927",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.139 514.262c.266-2.283-1.301-4.34-3.431-4.648-2.13-.309-4.115 1.235-4.381 3.517-.265 2.283 1.302 4.341 3.432 4.648 2.13.309 4.115-1.235 4.38-3.517z",
  fill: "#fff",
  stroke: "#EC7EB0",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.461 519.537c.265-2.282-1.302-4.339-3.432-4.646-2.13-.309-4.114 1.235-4.379 3.517-.266 2.283 1.301 4.34 3.431 4.648 2.13.308 4.115-1.236 4.38-3.518v-.001z",
  fill: "#fff",
  stroke: "#FFDB00",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M458.766 541.3c.265-2.284-1.302-4.34-3.432-4.649-2.13-.307-4.115 1.236-4.38 3.519-.265 2.283 1.301 4.34 3.432 4.648 2.13.307 4.115-1.236 4.38-3.518z",
  fill: "#fff",
  stroke: "#53C0DA",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M570.227 498.038c-7.628-9.747-24.914-9.014-33.552 0-6.322 6.597-4.902 13.597-3.355 22.255 2.067 11.569 4.849 26.336 17.614 25.324 11.315-.896 12.092-12.478 15.937-22.254 3.687-9.374 9.694-17.225 3.356-25.325z",
  fill: "#D1DA65"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550.981 491s2.049 11.27 0 17.463c-2.636 7.972-16.703 17.463-16.703 17.463M573 503.907s-9.111 3.037-18.981 13.667c-9.871 10.63-9.111 27.333-9.111 27.333",
  stroke: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#about-science_svg__clip0_831_55512)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M624.053 543.926s.027.002.038.009l-.038-.009s21.153-12.105 39.332-5.683c21.15 7.461 25.362 25.069 25.607 27.275 0 0 .008.105.001.115-1.513 1.609-15.408 13.092-36.811 6.415-18.399-5.752-28.129-28.122-28.129-28.122z",
  fill: "#D2EEDD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M657.45 526.103a2.45 2.45 0 01.811 2.114 2.454 2.454 0 01-.911 1.652 2.456 2.456 0 01-3.463-.386 2.467 2.467 0 01.384-3.462 2.457 2.457 0 013.175.081l.004.001zM663.403 529.081c.234.291.342.658.301 1.033a1.421 1.421 0 01-.519.944 1.402 1.402 0 01-1.815-.045l-.165-.172a1.41 1.41 0 01.214-1.978 1.403 1.403 0 011.815.045l.165.172.004.001z",
  fill: "#4CBA78"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642.201 534.77v33.415",
  stroke: "#53C0DA",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M664.967 539.082v27.682",
  stroke: "#FFDB00",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.48 536.338v30.967",
  stroke: "#53C0DA",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M653.992 553.588l.001 13.8",
  stroke: "#EC7EB0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "about-science_svg__clip0_831_55512"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(620 521)",
  d: "M0 0h69v69H0z"
})));

function SvgAboutScience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 956,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "about-science_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1024,
    height: 956
  }, _ref), _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/about-science.ae429f8b.svg";
export { SvgAboutScience as ReactComponent };